import { render, staticRenderFns } from "./bag-list-item.vue?vue&type=template&id=4c4b63a2&scoped=true&lang=html"
import script from "./bag-list-item.vue?vue&type=script&lang=js"
export * from "./bag-list-item.vue?vue&type=script&lang=js"
import style0 from "./bag-list-item.vue?vue&type=style&index=0&id=4c4b63a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4b63a2",
  null
  
)

export default component.exports